import type { DrawerProps } from '@meterup/atto';
import { Drawer as AttoDrawer, styled, zIndexes } from '@meterup/atto';
import { createPortal } from 'react-dom';

import { applicationValues } from './shared';

const DrawerContainer = styled('div', {
  zIndex: zIndexes.drawer,
  right: 0,
  bottom: 0,
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '1fr',
  gridTemplateAreas: '"drawer"',
  justifyContent: 'flex-end',
  transition: 'transform 0.2s ease-in-out',
  pointerEvents: 'none',

  '@mobile': {
    position: 'fixed',
    top: `$${applicationValues.ends.height['@notDesktop']}`,
    left: 0,
    right: 0,
    bottom: 0,
  },

  '@notMobile': {
    position: 'absolute',
    top: 0,
  },

  '@tablet': {
    left: 0,
  },

  '@desktop': {
    widthAll: '$384',
  },

  variants: {
    open: {
      true: {
        transform: 'translateX(0)',
      },
      false: {
        transform: 'translateX(120%)',
      },
    },
  },
});
DrawerContainer.displayName = 'DrawerContainer';

export function DrawerPortal({
  children,
  ...remaining
}: { children: React.ReactNode } & DrawerProps) {
  const mount = document.getElementById('drawer-portal');

  if (!mount) {
    return null;
  }

  return createPortal(<AttoDrawer {...remaining}>{children}</AttoDrawer>, mount);
}

export function Drawer({ children, open = false }: { children: React.ReactNode; open: boolean }) {
  return (
    <>
      <DrawerContainer open={open}>{children}</DrawerContainer>
      <DrawerContainer open id="drawer-portal" />
    </>
  );
}
